import CategorySelector from "@main/categories/components/CategorySelector";

const filterUIConfig = {
  uiScheme: {
    classNames: "filters-container",
    search: {
      "ui:options": {
        label: false, // Oculta el título del campo
        placeholder: "Buscar...",
      },      
    },
    category_id: {
      "ui:widget": "category-selector",
      "ui:options": {
        label: false, // Oculta el título del campo
        placeholder: "Filtrar por categoría",
      },   
    }
  },
  widgets: {
    'category-selector': CategorySelector,
  },
};
const getFilterUIConfig: any = (type: string) => {
  return filterUIConfig;
};
export default getFilterUIConfig;
